import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import { GiftItemRow } from '@models/gift';

import InfoIcon from './InfoIcon';
import SearchIcon from './SearchIcon';
import styles from './styles.module.scss';

interface Props {
    gitItem: GiftItemRow;
}

function ItemInfo({ gitItem }:Props) {
  const {
    status, name, imageUrl, description,
  } = gitItem;
  return (
        <Column as='section' fullWidth
                className={styles.container}
                spacing={12}
                align='center'>
            <div className={styles.imageContainer}>
                <Image src={imageUrl}
                       width={100}
                       height={100}
                       alt=''/>
                {status === 'SOLD_OUT' && (
                    <div className={styles.soldout}>
                        SOLDOUT
                    </div>
                )}
            </div>
            <Text size='3xl' fontWeight='bold'>
                {name}
            </Text>
            {description && (
                <Text>{description}</Text>
            )}
        </Column>
  );
}

export default ItemInfo;
